import { render, staticRenderFns } from "./availability_spklu.vue?vue&type=template&id=4e3c428f&scoped=true&"
import script from "./availability_spklu.vue?vue&type=script&lang=js&"
export * from "./availability_spklu.vue?vue&type=script&lang=js&"
import style0 from "./availability_spklu.vue?vue&type=style&index=0&id=4e3c428f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c428f",
  null
  
)

export default component.exports